import type { Infer } from 'superstruct';
import { assign, object, string } from 'superstruct';

import { IdObjectWithName } from '@adflow/shared/util-superstruct';

export const HistoryGoogleAdsAccountDto = assign(
	IdObjectWithName,
	object({ avbId: string() })
);

export type HistoryGoogleAdsAccountDto = Infer<
	typeof HistoryGoogleAdsAccountDto
>;
